import {RoleBasedPermission} from '@hconnect/apiclient'
import {useUpmPlantContext} from '@hconnect/upm'
import {usePermission} from '@hproduce/permissions'

export const useCanDeleteRefractory = (): boolean => {
  const {plantId, country} = useUpmPlantContext()

  return usePermission({
    plantContext: {plantId, countryId: country},
    permissionTypes: [RoleBasedPermission.HproduceRoleCCCSupporter]
  })
}
